export const API_BASE_URL = "https://api.vpeters.org/api/v1";
export const SOCKET_URL = "https://api.vpeters.org";
// export const API_BASE_URL = "http://192.168.0.131:3666/api/v1";
// export const SOCKET_URL = "http://192.168.0.131:3666";
